export interface IDistributionChannel {
  _id: string
  objectId: string
  name: string
  type: EDistributionChannelType | string
  url: string
  ref: string
  merchant: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  isActive: boolean
}

export enum EDistributionChannelType {
  FACEBOOK = 'facebook',
  TIKTOK = 'tiktok',
  INSTAGRAM = 'instagram',
  SHOPEE = 'shopee',
  LAZADA = 'lazada',
  LINE = 'line',
  ETC = 'etc',
}
